var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7684L17.9971 22.32C18.9434 22.8802 20.1104 22.0477 19.8594 20.9925L18.2675 14.2977L23.567 9.79261C24.4022 9.08322 23.9557 7.73668 22.855 7.64549L15.879 7.06519L13.1502 0.746992C12.7193 -0.248997 11.2807 -0.248997 10.8498 0.746992L8.12099 7.06519L1.14504 7.64549C0.044341 7.73668 -0.402216 9.08322 0.432966 9.79261L5.73251 14.2977L4.1406 20.9925C3.88956 22.0477 5.05664 22.8802 6.00286 22.32L12 18.7684Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star-gray.a276ee4a9ea625462e47276c8957b783.svg";
export { ForwardRef as ReactComponent };